# Generated from app.intent.md — do not edit manually
# Route: /materials/lots
# Audience: Operators (md+), blocked on sm
# Ref: app.intent.md § Material Lot List

page-lot-list:
  type: Page
  archetype: list
  meta:
    title: $t.lot_list.meta_title
    auth: required
  data:
    lots:
      model: ItemLot[]
      # F73 — F902c required filter. /api/items/lots requires one of
      # itemDefinitionId, qualityStatus. Seed with qualityStatus=RELEASED
      # so the page mounts; the lot-list filter controls (when added)
      # let operators widen to QUARANTINE / SAMPLING / REJECTED.
      # Valid statechart states from item-lot-lifecycle.statechart.yaml.
      filter:
        qualityStatus: RELEASED
      refresh: on_mount
      data_states:
        loading:
          skeleton_count: 5
        empty:
          ref: lot-list-empty
        error: default
  spatial:
    display: flex
    direction: column
    gap: $spacing.lg
    padding: $spacing.lg
    padding_inline: $spacing.xl
    overflow: auto
  tokens:
    background: $color_scheme.light.color.surface
  children:
    - lot-list-sm-notice
    - lot-list-content

# ── sm viewport notice ───────────────────────────────────────────────────────

lot-list-sm-notice:
  type: SmNotice
  content: $t.common.sm_notice_tablet

# ── Main content (hidden on sm) ──────────────────────────────────────────────

lot-list-content:
  type: Section
  spatial:
    display: flex
    direction: column
    gap: $spacing.lg
    responsive:
      sm:
        display: none
  children:
    - lot-list-header
    - lot-list-filter
    - lot-list-table

# ── Header ───────────────────────────────────────────────────────────────────

lot-list-header:
  type: PageHeader
  content: $t.lot_list.title
  actions:
    - label: $t.lot_list.btn_receive
      route: /materials/lots/receive
      color: info
      # F79 — Cancel / on_success on the receive screen returns to this list.
      return_context: origin_only
  hide_actions_on_sm: true

# ── Filter ───────────────────────────────────────────────────────────────────

lot-list-filter:
  type: Section
  spatial:
    display: flex
    gap: $spacing.md
    align: center
  children:
    - lot-list-filter-status
    - lot-list-filter-clear

lot-list-filter-status:
  type: Input
  input_type: select
  model: ItemLot
  label: $t.lot_list.filter_status
  bind:
    value: qualityStatus
  a11y:
    label: $t.lot_list.filter_status_label
  spatial:
    min_height: touch-safe
    max_width: 12rem
  tokens:
    border: $border.default
    radius: $radius.md
    font_size: $font.size.sm

lot-list-filter-clear:
  type: Button
  variant: ghost
  content: $t.common.filter_clear
  a11y:
    label: $t.common.filter_clear_label
  action:
    type: custom
  spatial:
    min_height: $size.touch-target
    padding_inline: $spacing.md

# ── Lot table ────────────────────────────────────────────────────────────────

lot-list-table:
  type: Table
  bind:
    rows: lots
  empty: lot-list-empty
  columns:
    - key: lotNumber
      label: $t.lot_list.col_lot_number
      tokens:
        font_family: $font.family.mono
        font_size: $font.size.sm
    - key: itemDefinitionId
      label: $t.lot_list.col_material
      tokens:
        font_size: $font.size.sm
    - key: currentQuantity.value
      priority: medium
      label: $t.lot_list.col_quantity
      tokens:
        font_family: $font.family.mono
        font_size: $font.size.sm
    - key: currentQuantity.unitOfMeasure
      priority: medium
      label: $t.lot_list.col_unit
      tokens:
        font_size: $font.size.sm
    - key: qualityStatus
      label: $t.lot_list.col_quality_status
      tokens:
        font_size: $font.size.sm
    - key: operationalStatus
      priority: low
      label: $t.lot_list.col_operational
      tokens:
        font_size: $font.size.sm
  row_action:
    type: navigate
    route: /materials/lots/:id
    params:
      id: $row.id
  a11y:
    label: $t.lot_list.table_label
  spatial:
    width: 100%
  tokens:
    border: $border.default
    radius: $radius.md
    background: $color_scheme.light.color.surface-elevated

lot-list-empty:
  type: EmptyState
  content: $t.lot_list.empty
  body: $t.lot_list.empty_body
  tokens:
    color: $color_scheme.light.color.on-surface-muted
    font_size: $font.size.md
  spatial:
    padding: $spacing.lg
